import { Network } from 'lucide-react'
import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Logo } from '../../components/Logo'

/**
 * Where a coordinator types the invitation code from their email (V58), instead of opening the
 * link. The invite page takes a code where it takes a link's token, so this only sends them there -
 * the same form, where they choose Seekers or Providers and set up their account.
 */
export function JoinWithCodePage() {
  const navigate = useNavigate()
  const [code, setCode] = useState('')

  function submit(e: FormEvent) {
    e.preventDefault()
    const clean = code.toUpperCase().replace(/[^A-Z0-9]/g, '')
    if (clean.length !== 8) return
    navigate(`/aggregator-portal/invite/${clean.slice(0, 4)}-${clean.slice(4)}`)
  }

  const ready = code.toUpperCase().replace(/[^A-Z0-9]/g, '').length === 8

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-sun-hero px-4 py-6">
      <div className="w-full max-w-md">
        <div className="text-center">
          <Link to="/" aria-label="YellowDots home" className="inline-block">
            <Logo size="page" />
          </Link>
          <h1 className="mt-4 flex items-center justify-center gap-2 text-3xl font-extrabold tracking-tight text-ink-900">
            <Network size={24} className="shrink-0 text-sun-600" />
            Join as a coordinator
          </h1>
          <p className="mt-1 text-ink-500">Enter the invitation code from the email your organisation sent you.</p>
        </div>
        <form onSubmit={submit} className="card mt-5 space-y-4 p-5 shadow-float sm:p-6">
          <label className="block">
            <span className="label label-required">Invitation code</span>
            <input
              autoFocus
              value={code}
              onChange={(e) => setCode(e.target.value)}
              maxLength={12}
              placeholder="XXXX-XXXX"
              autoComplete="off"
              className="input text-center font-mono text-2xl uppercase tracking-[0.3em]"
            />
          </label>
          <button type="submit" disabled={!ready} className="btn-sun w-full disabled:opacity-40">
            Continue
          </button>
        </form>
        <p className="mt-5 text-center text-sm text-ink-500">
          Already joined?{' '}
          <Link to="/aggregator-portal/login" className="font-semibold text-ink-900 hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  )
}
